// @flow
import React, { Component } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Statistic extends Component<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone-subarea", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
        <title>Bioestatística</title>
        <desc>Um gráfico com uma linha ascendente</desc>
        <g id="icon-sup-statistic">
          <path d="M63,62H2V1A1,1,0,0,0,0,1V63a1,1,0,0,0,1,1H63a1,1,0,0,0,0-2Z" />
          <path d="M8,50a2,2,0,0,0,2-2,2.09,2.09,0,0,0-.07-.51L23.49,33.93A2.09,2.09,0,0,0,24,34a2,2,0,0,0,1.1-.33L38,40.12A2,2,0,0,0,42,40a1.91,1.91,0,0,0-.17-.8L61.79,12,62,12a2,2,0,1,0-2-2,1.91,1.91,0,0,0,.17.8L40.21,38,40,38a2,2,0,0,0-1.1.33L26,31.88A2,2,0,0,0,22,32a2.09,2.09,0,0,0,.07.51L8.51,46.07A2.09,2.09,0,0,0,8,46a2,2,0,0,0,0,4Z" />
        </g>
      </svg>
    );
  }
}

export default Statistic;
